import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import TwoColumnPrimaryBackground from "components/faqs/TwoColumnPrimaryBackground";
import MainFeature1 from "components/features/TwoColWithButton.js";
import deneme from "images/uni-min.jpg";
import deneme3 from "images/iki.jpg";
import tw from "twin.macro";

const Subheading = tw.span`uppercase tracking-wider text-sm`;

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <MainFeature1
        subheading=""
        heading="The Researcher"
        buttonRounded={false}
        primaryButtonText="See Details"
        description="My name is Pinar Celik Chippari.
        I am a Doctoral Student in Education at Queens University Belfast. My supervisors are Prof Dirk Schubotz and Dr Alison MacKenzie. I am a qualified Special Education teacher trained in sexual health education, and I am currently a School Service Volunteer for the NSPCC."
        imageSrc={deneme}
      />

      <MainFeature1
        subheading={<Subheading>About My Research</Subheading>}
        heading="My research explores the topic of self-protection skills among young people."
        buttonRounded={false}
        primaryButtonText="See Form"
        primaryButtonUrl="https://forms.office.com/pages/responsepage.aspx?id=6ner6qW040mh6NbdI6HyhqHkrzKDbDdBlSbjzvazn51UMkNBQTJTMjROQkpETDBVWENQUEFNQzlHVS4u"
        imageSrc={deneme3}
        textOnLeft={false}
        description="My research explores the topic of self-protection skills among young people. My goal is to develop an interactive web-based application that can be used to educate children with disabilities about private body parts, distinguishing between appropriate and inappropriate touches, and improving their confidence to discuss sexual health."
      />

      <TwoColumnPrimaryBackground />
      <Footer />
    </AnimationRevealPage>
  );
};
